async function openCart(skipFetch = !1) {
    document.querySelector("#miniCart:not([open])") &&
        document.querySelector("#miniCart").showModal(),
        document.querySelector("body").classList.add("noScroll"),
        document.querySelector("#miniCartEmpty").classList.remove("active"),
        document.querySelector("#miniCartHeader").classList.remove("active"),
        document.querySelector("#miniCartBody").classList.remove("active"),
        document.querySelector("#miniCartUpsell").classList.remove("active"),
        document.querySelector("#miniCartFooter").classList.remove("active"),
        document.querySelector("#miniCartContent").classList.add("loading"),
        skipFetch === !1 &&
        (cart = await fetch("/cart.js").then(function(data) {
            return data.json();
        }));
    const itemsToRemove = [];
    if (itemsToRemove.length > 0) {
        let updatePayload = {};
        if (
            (itemsToRemove.forEach((item) => {
                    updatePayload[item.key] = 0;
                }),
                Object.keys(updatePayload).length > 0)
        ) {
            (cart = await updateCart({
                updates: updatePayload
            })), await openCart(!0);
            return;
        }
    }

    // // BUY X GET Y FREE
    // const BUY_2_GET_1_VARIANT_SKUS = [
    //   "popularonetime",
    //   "popularsub",
    // ];
    // const BUY_1_GET_1_VARIANT_SKUS = [
    //   "premiumonetime",
    //   "premiumsub",
    // ];

    // const original_items = cart.items.filter((item) => item.discounted_price > 0);
    // for (let i = 0; i < original_items.length; i++) {
    //   const org_item = original_items[i];
    //   const dis_item = cart.items.find((item) => item.variant_id == org_item.variant_id && item.discounted_price == 0);
    //   const discounted_quantity = dis_item?.quantity ?? 0;
      
    //   let eligibleSets = 0;
    //   if (BUY_2_GET_1_VARIANT_SKUS.includes(org_item.sku)) {
    //     eligibleSets = Math.floor(org_item.quantity / 2); // Every 3 items = 1 free
    //   } else if (BUY_1_GET_1_VARIANT_SKUS.includes(org_item.sku)) {
    //     eligibleSets = Math.floor(org_item.quantity / 1); // Every 2 items = 1 free
    //   }

    //   if (eligibleSets != discounted_quantity) {
    //       console.log(eligibleSets, discounted_quantity);
    //     // if (dis_item) {
    //     //   await changeProduct({
    //     //       id: dis_item.key,
    //     //       eligibleSets
    //     //   });
    //     // } else {
    //     //   await addProduct({
    //     //     id: org_item.id,
    //     //     eligibleSets
    //     //   });
    //     // }
    //     // await openCart(!0);
    //     // return;
    //   }
    // }
  
    if (
        (document.querySelector("#miniCartContent").classList.remove("loading"),
            document.querySelector("#headerCart") &&
            (document.querySelector(
                "#headerCart"
            ).textContent = `CART (${cart.item_count})`),
            cart.item_count === 0)
    ) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        return;
    }

    document.querySelector("#miniCartHeader").classList.add("active"),
        document.querySelector("#miniCartBody").classList.add("active"),
        document.querySelector("#miniCartUpsell").classList.add("active"),
        document.querySelector("#miniCartFooter").classList.add("active"),
        document
        .querySelectorAll(".miniCartBodyItem:not(#miniCartBodyFreeContainer)")
        .forEach((element) => element.remove());
    let subscriptionItems = 0;
    cart.items.forEach((item) => {
            item.handle !== "respire-nasal-sticks-mint" &&
                item.selling_plan_allocation &&
                (subscriptionItems += item.quantity);
        }),
        subscriptionItems > 0 ?
        ((document.querySelector("#miniCartHeaderShipping").innerHTML =
                "You've unlocked <b>FREE SHIPPING</b>"),
            document
            .querySelector("#miniCartHeaderBarInner")
            .classList.add("active")) :
        ((document.querySelector("#miniCartHeaderShipping").innerHTML =
                "Upgrade to a subscription for <b>FREE SHIPPING</b>"),
            document
            .querySelector("#miniCartHeaderBarInner")
            .classList.remove("active")),
        (document.querySelector("#miniCartFooterCheckoutPrice").textContent = price(
            cart.items_subtotal_price
        )),
        cart.items.forEach(function(item) {
            console.log('item', item);

            function variantHTML() {
                return item.variant_title === null ?
                    "" :
                    `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
            }

            function subscriptionHTML() {
                return item.selling_plan_allocation ?
                    `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>` :
                    "";
            }

            function priceHTML() {
                let HTML = "",
                    comparePrice = null;
                if (
                    (item.selling_plan_allocation ?
                        (comparePrice =
                            item.selling_plan_allocation.compare_at_price * item.quantity) :
                        item.original_line_price > item.final_line_price &&
                        (comparePrice = item.original_line_price),
                        comparePrice && (HTML += `<s>${price(comparePrice, !1)}</s>`),
                        (HTML += price(item.final_line_price, !1)),
                        comparePrice)
                ) {
                    let savings = comparePrice - item.final_line_price;
                    savings > 0 && (HTML += `<span>(Save ${price(savings, !1)})</span>`);
                }
                return HTML;
            }

            function upgradeHTML() {
                if (item.selling_plan_allocation) return "";
                let sellingPlanID = item.selling_plan_allocation?.selling_plan?.id,
                    sellingPlanName = item.selling_plan_allocation?.selling_plan?.name;
                return sellingPlanID ?
                    `
                <button 
                    class="miniCartBodyItemUpgrade button"
                     data-key="${item.key}"
                     data-id="${item.variant_id}" 
                     data-plan="${sellingPlanID}"
                >
                    ${sellingPlanName}
                </button>
            ` :
                    "";
            }
            document.querySelector("#miniCartBody").insertAdjacentHTML(
                "beforeend",
                `
            <div class="miniCartBodyItem" key="${item.key}" data-id="${item.variant_id}">
                <img class="miniCartBodyItemImage" src="${
                  item.image
                }&width=400">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${
                              item.product_title
                            }</div>
                            ${variantHTML()}
                            ${subscriptionHTML()}
                        </div>
                        <button class="miniCartBodyItemRemove">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.28125 3.28125L3.86719 12.6562C3.89502 13.1979 4.28906 13.5938 4.80469 13.5938H10.1953C10.713 13.5938 11.0997 13.1979 11.1328 12.6562L11.7188 3.28125" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.34375 3.28125H12.6562H2.34375Z" fill="#8F8F8F"></path><path d="M2.34375 3.28125H12.6562" stroke="#8F8F8F" stroke-width="0.9375" stroke-miterlimit="10" stroke-linecap="round"></path><path d="M9.60938 5.15625L9.375 11.7188M5.625 3.28125V2.10938C5.62473 2.01697 5.64273 1.92541 5.67797 1.83998C5.71321 1.75455 5.76499 1.67693 5.83034 1.61159C5.89568 1.54624 5.9733 1.49446 6.05873 1.45922C6.14416 1.42398 6.23571 1.40598 6.32812 1.40625H8.67188C8.76429 1.40598 8.85584 1.42398 8.94127 1.45922C9.0267 1.49446 9.10432 1.54624 9.16966 1.61159C9.23501 1.67693 9.28679 1.75455 9.32203 1.83998C9.35727 1.92541 9.37527 2.01697 9.375 2.10938V3.28125H5.625ZM7.5 5.15625V11.7188V5.15625ZM5.39062 5.15625L5.625 11.7188L5.39062 5.15625Z" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </button>
                    </div>
                    <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus" ${item.discounted_price === 0 ? "disabled" : ""}>-</button>
                            <div class="miniCartBodyItemQuantityCount">${
                              item.quantity
                            }</div>
                            <button class="miniCartBodyItemQuantityPlus" ${item.discounted_price === 0 ? "disabled" : ""}>+</button>
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                </div>
                ${upgradeHTML()}
            </div>
        `
            );
        }),
        document
        .querySelectorAll(".miniCartBodyItem:not(#miniCartBodyFreeContainer)")
        .forEach(function(element) {
            let key = element.getAttribute("key"),
                variantId = element.dataset.id,
                quantity = parseInt(
                    element.querySelector(".miniCartBodyItemQuantityCount").textContent
                );
            element
                .querySelector(".miniCartBodyItemQuantityMinus")
                .addEventListener("click", function() {
                    quantity === 1 ?
                        element.querySelector(".miniCartBodyItemRemove").click() :
                        (quantity--, updateCartItem());
                }),
            element
                .querySelector(".miniCartBodyItemQuantityPlus")
                .addEventListener("click", function() {
                    quantity++, updateCartItem();
                }),
            element
                .querySelector(".miniCartBodyItemRemove")
                .addEventListener("click", function() {
                    (quantity = 0),
                    updateCartItem(),
                        element.classList.add("fade"),
                        setTimeout(() => {
                            element.remove();
                        }, 500);
                });
            async function updateCartItem() {
                (element.querySelector(".miniCartBodyItemQuantityCount").textContent =
                    quantity),
                (cart = await changeProduct({
                    id: key,
                    quantity
                })),
                await openCart(!0);
            }
            element
                .querySelector(".miniCartBodyItemUpgrade")
                ?.addEventListener("click", async function() {
                    const key2 = this.dataset.key,
                        variantID = parseInt(this.dataset.id),
                        sellingPlanID = parseInt(this.dataset.plan);
                    this.classList.add("loading"),
                        await changeProduct({
                            id: key2,
                            quantity: 0
                        }),
                        await addProduct({
                            items: [{
                                quantity: 1,
                                id: variantID,
                                selling_plan: sellingPlanID
                            }, ],
                        }),
                        await openCart(),
                        this.classList.remove("loading");
                });
        }),
        document.querySelectorAll(".miniCartUpsellItem").forEach((element) => {
            let productID = parseInt(element.dataset.product),
                isProductInCart = cart.items.find(
                    (item) => item.product_id === productID
                );
            cart.items.find(
                    (item) => item.handle === "listicle-v2-respire-sleep-strips-3-pack"
                ) &&
                (productID === 8558405026074 || productID === 8567567286554) &&
                (isProductInCart = !0),
                isProductInCart ?
                element.classList.remove("active") :
                element.classList.add("active");
        }),
        document.querySelectorAll(".miniCartUpsellItem.active").length === 0 &&
        document.querySelector("#miniCartUpsell").classList.remove("active"),
        document.querySelector("#miniCartFooterUpsellTopSwitchInput").checked ?
        (document.querySelector("#miniCartFooterCheckoutPrice").textContent =
            price(cart.items_subtotal_price + 0)) :
        (document.querySelector("#miniCartFooterCheckoutPrice").textContent =
            price(cart.items_subtotal_price));
}
document
    .querySelectorAll(".miniCartUpsellItemWrapATC")
    .forEach(function(element) {
        element.addEventListener("click", async function() {
            const variantID = this.closest(".miniCartUpsellItem").dataset.variant;
            this.classList.add("loading");
            let formData = {
                items: [{
                    quantity: 1,
                    id: variantID
                }]
            };
            if (this.closest(".miniCartUpsellItem").dataset.plan) {
                let sellingPlanID = this.closest(".miniCartUpsellItem").dataset.plan;
                formData = {
                    items: [{
                        quantity: 1,
                        id: variantID,
                        selling_plan: sellingPlanID
                    }],
                };
            }
            await addProduct(formData),
                this.classList.remove("loading"),
                await openCart();
        });
    }),
    document
    .querySelector("#miniCartFooterUpsellTopSwitchInput")
    .addEventListener("change", async function() {
        await openCart(!0);
    }),
    document.querySelector("#miniCart").addEventListener("close", function() {
        document.querySelector("body").classList.remove("noScroll");
    });

function closeCart() {
    document.querySelector("#miniCart").close();
}
document.querySelectorAll(".openCart").forEach(function(element) {
        element.addEventListener("click", function() {
            openCart();
        });
    }),
    document.querySelectorAll(".closeCart").forEach(function(element) {
        element.addEventListener("click", closeCart);
    }),
    document.querySelector("#miniCart").addEventListener("click", function(e) {
        e.target === this && closeCart();
    }),
    document
    .querySelector("#miniCartFooterCheckout")
    .addEventListener("click", async function() {
        this.classList.add("loading");
        let formData = {
                items: []
            },
            subscriptionItems = 0;
        cart.items.forEach((item) => {
                item.handle !== "respire-nasal-sticks-mint" &&
                    item.selling_plan_allocation &&
                    (subscriptionItems += item.quantity);
            }),
            // subscriptionItems > 0 &&
            //   (await addProduct({
            //     quantity: subscriptionItems,
            //     id: freeContainerID,
            //   })),
            // cart.items_subtotal_price < 12300 &&
            //   (subscriptionItems === 0 ||
            //     cart.items.some((item) => item.title.includes("1 Pack"))) &&
            //   !cart.items.some((item) => item.handle === "breathing-drops") &&
            //   (await openUpsell()),
            // document.querySelector("#miniCartFooterUpsellTopSwitchInput").checked &&
            //   (await addProduct({ quantity: 1, id: protectionVariantID })),
            this.classList.remove("loading"),
            (window.location.href = "/checkout");
    }),
    dialogPolyfill.registerDialog(document.querySelector("#miniCart")),
    document.referrer.includes("/cart") && openCart();
async function openUpsell() {
    document.querySelector("#upsell").showModal(),
        document.querySelector("body").classList.add("noScroll"),
        await new Promise((resolve, reject) => {
            document.querySelector("#upsell").addEventListener("close", function(e) {
                resolve("closed");
            });
        });
}
document
    .querySelector("#upsellContentBodyControlsATC")
    .addEventListener("click", async function() {
        this.classList.add("loading"), await fetch("/cart/clear.js");
        let formData = {
            items: [{
                quantity: 1,
                id: parseInt(this.dataset.id)
            }]
        };
        await addProduct(formData), this.classList.remove("loading"), closeUpsell();
    }),
    document.querySelector("#upsell").addEventListener("close", function() {
        document.querySelector("body").classList.remove("noScroll");
    });

function closeUpsell() {
    document.querySelector("#upsell").close();
}
document.querySelectorAll(".closeUpsell").forEach(function(element) {
        element.addEventListener("click", closeUpsell);
    }),
    document.querySelector("#upsell").addEventListener("click", function(e) {
        e.target === this && closeUpsell();
    });
//# sourceMappingURL=/cdn/shop/t/46/assets/theme-mini-cart.js.map?v=42647328521317815311739833081